import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileNavOpen(false);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng).then(() => {
      console.log('Language changed to:', lng);
    }).catch((err) => {
      console.error('Error changing language:', err);
    });
  };

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <div className="logo">
            <span className="logo-text">
              <span className="logo-bold">Bravo</span>
              <span>Energy</span>
            </span>
          </div>

          {/* Navigation Desktop */}
          <nav className="nav-desktop">
            <ul className="nav-list">
              <li><a href="/#accueil" onClick={() => scrollToSection('accueil')}>{t('nav.home')}</a></li>
              <li><a href="/#services" onClick={() => scrollToSection('services')}>{t('nav.services')}</a></li>
              <li><a href="/#panneaux-solaires" onClick={() => scrollToSection('panneaux-solaires')}>{t('nav.panneaux')}</a></li>
              <li><a href="/#coordination" onClick={() => scrollToSection('coordination')}>{t('nav.coordination')}</a></li>
              <li><a href="/#temoignages" onClick={() => scrollToSection('temoignages')}>{t('nav.testimonials') || 'Témoignages'}</a></li>
              <li><a href="/#faq" onClick={() => scrollToSection('faq')}>{t('nav.faq')}</a></li>
              <li><a href="/#blog" onClick={() => scrollToSection('blog')}>{t('nav.blog') || 'Blog'}</a></li>
              <li><a href="/#contact" onClick={() => scrollToSection('contact')}>{t('nav.contact')}</a></li>
            </ul>
          </nav>

          {/* CTA et Langue - Desktop uniquement */}
          <div className="header-actions desktop-only">
            <div className="lang-switch">
              <button 
                type="button"
                className={i18n.language === 'fr' ? 'active' : ''}
                onClick={() => {
                  changeLanguage('fr');
                }}
              >
                FR
              </button>
              <span className="separator">|</span>
              <button 
                type="button"
                className={i18n.language === 'nl' ? 'active' : ''}
                onClick={() => {
                  changeLanguage('nl');
                }}
              >
                NL
              </button>
            </div>
            <a href="/contact" className="btn btn-primary btn-header">
              {t('nav.cta')}
            </a>
          </div>

          {/* Actions Mobile: Langue + Hamburger */}
          <div className="mobile-actions-inline mobile-only">
            <div className="lang-switch">
              <button 
                type="button"
                className={i18n.language === 'fr' ? 'active' : ''}
                onClick={() => {
                  changeLanguage('fr');
                }}
              >
                FR
              </button>
              <span className="separator">|</span>
              <button 
                type="button"
                className={i18n.language === 'nl' ? 'active' : ''}
                onClick={() => {
                  changeLanguage('nl');
                }}
              >
                NL
              </button>
            </div>
            <button 
              className="mobile-menu-btn"
              onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}
              aria-label="Menu"
            >
              <div className="hamburger-lines">
                <span className={`line line1 ${isMobileNavOpen ? 'active' : ''}`}></span>
                <span className={`line line2 ${isMobileNavOpen ? 'active' : ''}`}></span>
                <span className={`line line3 ${isMobileNavOpen ? 'active' : ''}`}></span>
              </div>
            </button>
          </div>
        </div>

        {/* Navigation Mobile - Menu déroulant complet */}
        <div className={`nav-mobile ${isMobileNavOpen ? 'open' : ''}`}>
          <nav className="mobile-nav-content">
            <ul className="nav-mobile-list">
              <li className="nav-item">
                <a href="/#accueil" onClick={() => scrollToSection('accueil')}>
                  <span className="nav-text">{t('nav.home') || 'Accueil'}</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="/#services" onClick={() => scrollToSection('services')}>
                  <span className="nav-text">{t('nav.services') || 'Services'}</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="/#coordination" onClick={() => scrollToSection('coordination')}>
                  <span className="nav-text">{t('nav.coordination') || 'Coordination'}</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="/#temoignages" onClick={() => scrollToSection('temoignages')}>
                  <span className="nav-text">{t('nav.testimonials') || 'Témoignages'}</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="/#faq" onClick={() => scrollToSection('faq')}>
                  <span className="nav-text">{t('nav.faq') || 'FAQ'}</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="/#blog" onClick={() => scrollToSection('blog')}>
                  <span className="nav-text">{t('nav.blog') || 'Blog'}</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="/#contact" onClick={() => scrollToSection('contact')}>
                  <span className="nav-text">{t('nav.contact') || 'Contact'}</span>
                </a>
              </li>
            </ul>

            {/* CTA placé en haut du menu mobile, à la place de l'ancien sélecteur de langue */}
            <div className="mobile-cta-row">
              <a href="/contact" className="btn btn-primary btn-mobile-cta" onClick={() => scrollToSection('contact')}>
                {t('nav.cta') || 'Prendre rendez-vous'}
              </a>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header; 